// Apolo IDE — MentionChip (Sprint v11 E2).
//
// Compact pill showing a parsed mention. Renders an icon + the target
// path/url, with a removable X. Designed to stack horizontally above the
// composer textarea so the user can scan pending mentions at a glance.

import { File, Folder, Globe, Hash, X } from 'lucide-react';

const ICONS = {
  file: File,
  folder: Folder,
  docs: Globe,
  symbol: Hash,
};

/**
 * @param {{
 *   type: 'file'|'folder'|'docs'|'symbol',
 *   target: string,
 *   resolved?: boolean,
 *   onRemove?: () => void,
 * }} props
 */
export default function MentionChip({ type, target, resolved = false, onRemove }) {
  const Icon = ICONS[type] || File;
  // (Pedro) context pills carry the Cursor accent (cursor.com/cloud) — a soft
  // tinted pill, not neutral gray — so @-context reads as a first-class chip.
  // Resolved stays green (it landed); pending uses the accent tint.
  const ringClass = resolved
    ? 'border-apolo-success/40 bg-apolo-successBg text-apolo-success'
    : 'border-apolo-accent/30 bg-apolo-accent/10 text-apolo-accent';
  return (
    <span
      className={`inline-flex max-w-[240px] items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] ${ringClass}`}
      title={`@${type}:${target}${resolved ? ' (resolved)' : ' (pending)'}`}
    >
      <Icon size={10} aria-hidden="true" className="shrink-0" />
      <span className="truncate">{target}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={`Remover menção a ${target}`}
          className="inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full text-apolo-textTertiary hover:bg-apolo-surface3 hover:text-apolo-textPrimary"
        >
          <X size={8} aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
